import { render, staticRenderFns } from "./addRoomViewList.vue?vue&type=template&id=3a1284c7&scoped=true"
import script from "./addRoomViewList.vue?vue&type=script&lang=js"
export * from "./addRoomViewList.vue?vue&type=script&lang=js"
import style0 from "./addRoomViewList.vue?vue&type=style&index=0&id=3a1284c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1284c7",
  null
  
)

export default component.exports